export const baseDate = new Date();